import { ProductTradeInProductImagesData } from '@features/product-page/api/trade-in/getProductImages';

import type { MappedOption, Variance } from './types';

export function filterOptions(options?: MappedOption[], selectedBrand?: number) {
  if (!options) return;
  if (!selectedBrand) return options;

  return options.filter(value => {
    if (typeof selectedBrand === 'undefined') return false;

    return Array.isArray(value)
      ? value.some(option => option.brandId === selectedBrand)
      : value.brandId === selectedBrand;
  });
}

export function filterOptionsByBrand(options?: MappedOption[], brandId?: number) {
  return options?.filter(option => option.brandId === brandId);
}

export function filterVariantOptions(options?: MappedOption[], selectedOption?: string | null) {
  if (!options) return;

  const variantsByOptionId = mapOptionsToVariants(options, 0);

  return selectedOption && variantsByOptionId?.[selectedOption]
    ? options?.filter(option =>
        Object.values(variantsByOptionId[selectedOption])
          .map(variant => variant.optionId)
          .includes(option.optionId)
      )
    : undefined;
}

export function mapOptionsToVariants(options: MappedOption[], level: number) {
  const variations: Record<string, Array<Variance & { optionId: number }>> = {};

  options?.forEach(option => {
    const variance = option.variances[level];
    const value = variance?.value;

    if (variance) {
      if (variations[value]) {
        variations[value].push({ ...variance, optionId: option.optionId });
      } else {
        variations[value] = variations[value]
          ? [...variations[value], { ...variance, optionId: option.optionId }]
          : [{ ...variance, optionId: option.optionId }];
      }
    }
  });

  return variations;
}

export function getImageId({
  variance,
  options,
  productImages
}: {
  variance: Variance & { optionId: number };
  options?: MappedOption[];
  productImages?: ProductTradeInProductImagesData | null;
}) {
  const productId =
    variance?.showImage &&
    productImages &&
    options?.find(option => option.optionId === variance.optionId)?.productIdForImage;

  return productId && productImages?.[`product_${productId}`]?.primaryImage.id;
}
